<template>
    <div class="cont_principal">
        <div class="container">
            <div class="row">
                <div class="container-fluid">
                    <h3 class="title">MES CERTIFICATIONS - LICENCES</h3>
                    <div class="container_cert">
		        <div v-for="(value, key) in certificat" :key="key" class="maj_comp_cert">
				<h4>{{ key.toUpperCase() }}</h4>
				<div v-for="(cert, index) in value" :key="index" class="div_card_cert">
		                        <div>
		                            <h5 class="title_cert">{{ cert.nom }}</h5>
                                            <div>{{ cert.obtention }}</div>
                                            <div class="info_cert">{{ cert.gestionnaire }}</div>
					    <span class="span_cert"></span>
			                </div>
			        </div>
			</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Certificats",
        props: ["certificat"],
    };
</script>

<style>
.maj_comp_cert {
        display: inline-block;
        position: relative;
}
.div_card_cert {
	width: 80%;
        display: inline-block;
        position: relative;
        align-items: center;
        justify-content: center;
        margin: 15px;
        padding: 20px;
        box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
}


    .cont_principal {
        margin: 0px;
        padding: 0px;
        background-color: #313131;
        color: white;
    }

.container_cert .ul_cert { 
  list-style: none;
  top: 50%;
  left: 50%;
  color: #fff;
  font-size: 13px;
}

.container_cert .ul_cert {
  content: '';
  height: 100%;
  border-left: 2px dashed #fff; 
}

.container_cert .ul_cert .li_cert {
  position: relative;
  margin-left: 30px ;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 14px;
  border-radius: 6px;
  width: 250px;
  box-shadow: 0 0 4px rgba(255, 255, 255, .12), 0 2px 2px rgba(255, 255, 255, .08)
}

.container_cert .ul_cert li:not(:first-child) {
  margin-top: 60px;
}

.container_cert .span_cert span:first-child {
  top: 0;
}

.container_cert .ul_cert .li_cert > span {
  width: 2px;
  height: 100%;
  background: #fff;
  left: -32px;
  top: 0;
  position: absolute;
}

.container_cert .ul_cert .li_cert > span:before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  background: #86b7e7;
  left: -4px;
  top: 0;
}

.container_cert span.span_cert span {
  position: absolute;
  text-align: left;
  left: 20px;
  width: 120px;
}

.container_cert {
  padding-bottom: 30px;
}

.title_cert {
  font-weight: bold;
}

</style>
